import { useContext, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { measurementAtom } from '../store/measurement';
import { DataContext } from '../../../entries/common/widgets/door-project/context';
import { ENDPOINTS } from '../const';

const DOOR_MEASUREMENT_SERVICE_ID = '2077';

type TResult = {
  isLoading: boolean;
  isAvailable: boolean;
};

export const useMeasurement = (): TResult => {
  const data = useContext(DataContext);
  const [measurement, setMeasurementState] = useRecoilState(measurementAtom);

  useEffect(() => {
    const api = data?.api;
    if (!__IS_SERVER__ && data?.regionId && api) {
      api
        .get(ENDPOINTS.GET_SERVICE({ serviceId: DOOR_MEASUREMENT_SERVICE_ID, regionId: data.regionId }), {})
        .then(res => {
          setMeasurementState(prevState => ({
            ...prevState,
            ...res,
            isLoaded: true,
          }));
        })
        .catch(() => {
          setMeasurementState(prevState => ({
            ...prevState,
            isLoaded: true,
            isError: true,
          }));
        });
    }
  }, [data, setMeasurementState]);

  return {
    isLoading: !measurement.isLoaded,
    isAvailable: measurement.isLoaded && !measurement.isError,
  };
};
